<template>
  <div class="decision-making-card pa-3 base-shadow rounded white">
    <div class="dmc-title d-flex justify-center align-center">
      <span class="white--text">{{ title }}</span>
    </div>
<!--    <div style="height: 410px; width: 100%;" class="d-flex">-->
<!--      <slot name="image">-->
<!--        <v-img :src="image"></v-img>-->
<!--      </slot>-->
<!--    </div>-->
    <div class="pb-5 pt-12" style="font-size: 16px; color: #878FA7; line-height: 32px">
      <slot name="card-text">
        <ul>
          <li v-for="(text, index) in contentText" :key="index">{{text}}</li>
        </ul>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'decision-making-card',
  props: {
    title: { type: String, required: true },
    contentText: { type: Array, default: () => [] },
    image: { type: String, default: '' }
  }
}
</script>

<style scoped>
 .decision-making-card {
   height: 100%;
   position: relative
 }
 .dmc-title {
   position: absolute;
   top: 0;
   left: 0;
   background-color: rgba(39,94,255,0.8);
   z-index: 3;
   height: 42px;
   width: 140px;
   border-radius: 6px 0;
   font-size: 22px
 }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/dss/decision-making-card.vue